<script>
import Titre from "@/components/atoms/titre";
import Card from "@/components/molecules/card";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";

export default {
  name: "BandeauTraiteur",
  components: {
    Titre,
    Card,
    Badge,
    Button,
    Icon
  },
  emits: ["click"]
};
</script>

<template>
  <Card
    radius="md"
    border-color="grey-5"
    class="c-traiteur-perma-banner-fp"
  >
    <div class="u-flex u-flex-column@sm u-flex-align-center@sm">
      <div class="c-traiteur-perma-banner-fp__logo-wrapper">
        <div class="c-traiteur-perma-banner-fp__logo">
          <Badge
            circle
            variant="white"
            size="xxxlg"
          >
            <Icon
              variant="traiteur"
              name="traiteur-permanent"
              size="lg"
            />
          </Badge>
        </div>
      </div>
      <div class="c-traiteur-perma-banner-fp__content-wrapper">
        <Titre
          tag="h1"
          size="sm"
          class="u-mb-xs u-text-center@sm"
        >
          Optez pour des produits traiteur sur commande&nbsp;!
        </Titre>
        <p class="u-font-15 u-mb-xxs u-mb-xs25@sm u-text-center@sm">
          Simple et rapide. Commandez vos produits traiteur en ligne et retirez-les en <br class="u-none@sm"> magasin sous 4 jours ouvrés.
        </p>
        <div class="u-text-center@sm">
          <Button
            link
            variant="primary"
            class="c-traiteur-perma__button"
            @click="$emit('click')"
          >
            En savoir plus
          </Button>
        </div>
      </div>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/traiteur-perma-banner-fp.scss";
</style>
